import React, { Component } from "react";
import "./ThankYou.css";
import ascentLogo from "../../assets/img/Ascent360-logo.svg";
import * as Constants from '../../utils/Constants';

export class ThankYou extends Component {

    constructor(props) {
        super(props);

        this.state = {
            integrationProviderName: undefined,
            provId: undefined
        };
    }

    componentDidMount() {
        let providerId = new URLSearchParams(window.location.search).get("ProviderId");
        if (providerId) {
            let obj = Constants.ExternalIntegrationProvider.find(({ id }) => id === providerId);
            this.setState({ integrationProviderName: (obj) ? obj.Name : "", provId: providerId });
        }
    }

    renderSwitch(providerId) {
        // display connect button with link for each provider
        switch (providerId) {
            case "59":
                return <a className="connect-lightspeed" href="https://services.shoplightspeed.com/login/?redirect=/store/apps/304/" >Connect Lightspeed eCom</a>;
            case "61":
                return <a className="connect-lightspeed" href="https://us.lightspeedapp.com/oauth/authorize.php?response_type=code&client_id=Ascent360&scope=employee:register_read+employee:inventory_read+employee:reports+employee:customers_read+employee:workbench" >Connect Lightspeed POS</a>;
            default:
                return <div />;
        }
    }

    render() {
        return (
            <div id="page-top">
                {/* Navigation */}
                <nav
                    className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top"
                    id="sideNav"
                >
                    <a className="navbar-brand js-scroll-trigger" href="#page-top">
                        <span className="d-lg-block">
                            <img
                                className="img-fluid img-logo"
                                src={ascentLogo}
                                alt="Ascent360"
                            />
                        </span>
                    </a>
                </nav>
                {/* Page Content */}
                <div className="container-fluid p-0">
                    <section className="content-section" id="thank-you">
                        <div className="content-section-wrap">
                            <h1 className="thankyou-text">Thank You!</h1>
                            <div className="content-container">
                                <p>
                                    Thank you for connecting your {this.state.integrationProviderName} store, we are now building your Customer Data Platform. This normally takes 1 or 2 days.
                                </p>
                                <p>
                                    Our team will be in touch and will send you an email once the system is ready!
                                </p>
                                <p className="d-flex justify-content-start my-4">
                                    {this.renderSwitch(this.state.provId)}
                                </p>
                                <p>
                                    <span className="bold">Have a question? </span>
                                    Email us at{" "}
                                    <a
                                        className="bold support"
                                        href="mailto:support@ascent360.com"
                                    >
                                        support@ascent360.com
                                    </a>
                                </p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}
